import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueResource from 'vue-resource'
import VueProgressBar from 'vue-progressbar'
import VueResourceProgressBarInterceptor from 'vue-resource-progressbar-interceptor'
import BootstrapVue from 'bootstrap-vue'
import i18n from './localization/i18n'
import InvisibleRecaptcha from 'vue-invisible-recaptcha'
import DatePicker from 'vue2-datepicker'
import VueQriously from 'vue-qriously'
import VueTheMask from 'vue-the-mask'
import VueHtmlToPaper from 'vue-html-to-paper'
import Ncalayer from './utils/ncalayer'
import SiteUtils from './utils/site'
import Config from './config.js'
import { Version } from './Version';

import 'vue-multiselect/dist/vue-multiselect.min.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-material-design-icons/styles.css'
import './utils/style.css'

window['sfd'] = {
    arm: {
        version: Version
    }
}

Vue.config.productionTip = false

Vue.use(Config)
Vue.use(Ncalayer)
Vue.use(SiteUtils)
Vue.use(VueResource)
Vue.use(BootstrapVue)
Vue.use(VueQriously)
Vue.use(VueTheMask)
Vue.use(VueHtmlToPaper, {
    name: '_blank',
    specs: [
        'fullscreen=yes',
        'titlebar=yes',
        'scrollbars=yes'
    ],
    styles: [
        'https://maxcdn.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css'
    ]
})
Vue.component('invisible-recaptcha', InvisibleRecaptcha)
Vue.component('date-picker', DatePicker)
Vue.component('base-component', () => import('./components/BaseComponent.vue'))
Vue.component('page-base', () => import('./components/PageBaseComponent.vue'))
Vue.component('multiselect', () => import('vue-multiselect'))
Vue.component('vue-bootstrap-typeahead', () => import('vue-bootstrap-typeahead'))
Vue.component('account-plus-icon', () => import('vue-material-design-icons/AccountPlus.vue'))
Vue.component('plus-icon', () => import('vue-material-design-icons/Plus.vue'))
Vue.component('magnify-icon', () => import('vue-material-design-icons/Magnify.vue'))
Vue.component('close-icon', () => import('vue-material-design-icons/Close.vue'))
Vue.component('help-icon', () => import('vue-material-design-icons/HelpCircle.vue'))
Vue.component('earth-icon', () => import('vue-material-design-icons/Earth.vue'))
Vue.component('logout-icon', () => import('vue-material-design-icons/Logout.vue'))
Vue.component('account-icon', () => import('vue-material-design-icons/AccountCircle.vue'))
Vue.component('save-icon', () => import('vue-material-design-icons/ContentSave.vue'))
Vue.component('download-icon', () => import('vue-material-design-icons/Download.vue'))
Vue.component('print-icon', () => import('vue-material-design-icons/Printer.vue'))
Vue.component('back-icon', () => import('vue-material-design-icons/KeyboardBackspace.vue'))
Vue.component('dots-icon', () => import('vue-material-design-icons/DotsVertical.vue'))

const options = {
    color: '#08c',
    failedColor: '#dc3545',
    thickness: '4px',
    transition: {
        speed: '0.35s',
        opacity: '0.6s',
        termination: 300
    },
    autoRevert: true,
    location: 'top',
    inverse: false,
    autoFinish: false
}
Vue.use(VueProgressBar, options)
Vue.use(VueResourceProgressBarInterceptor)

Vue.http.interceptors.push(function () {
    store.commit('toggleLoading')
    return function (response) {
        if (response.body.code === 210 || response.body.code === 211) {
            store.commit('logout')
            this.$ncalayer.breakSession(null)
            router.push('/login')
        }
        
        if (response.headers.has('token-expiry-seconds')) {
            const expiryDate = new Date(Date.now() + parseInt(response.headers.get('token-expiry-seconds')) * 1000);
            store.commit('updateTokenExpiryDate', expiryDate);
        }

        store.commit('toggleLoading')
    }
})

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
